<template>
    <div class="Assets">
        <HeaderReturn title="通证管理记录"></HeaderReturn>
        <div class="record">
            <ul>
                <li>
                    <div>通证管理</div>
                    <div>
                        <p>状态</p>
                        <p>时间</p>
                    </div>
                    <div>
                        操作
                    </div>
                </li>
            </ul>
        </div>






    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon } from 'vant';
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            TeamList: [
                {
                    url: require('../../assets/img/page/chongbi.png'),
                    txt: "充值",
                    id: 0,
                    path: '/My/recharge'
                },
                {
                    url: require('../../assets/img/page/tibi.png'),
                    txt: "提币",
                    id: 1,
                    path: '/My/withdrawal'

                },
                {
                    url: require('../../assets/img/page/shandui.png'),
                    txt: "闪兑",
                    id: 2,
                    path: "/My/flashExchange"
                }
            ],
            AccasetList: [{
                coin: 'FIL',
                value: 100,
                freeze: 100,
                id: 0
            }, {
                coin: 'FIL',
                value: 100,
                freeze: 100,
                id: 1
            }, {
                coin: 'FIL',
                value: 100,
                freeze: 100,
                id: 2
            }]


        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
    },
    methods: {
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path, item) {
            if (path) {
                this.$router.push({
                    path,
                    query: {
                        item: JSON.stringify(item),
                    }
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.Assets {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #fff;
    }

    .record {
        ul {
            li {
                padding: 10px 10px;
                &:nth-child(1) {
                    font-family: 'PingFang SC';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 22px;
                    color: #f89b19;
                    display: flex;
                    justify-content: space-between;
                    div {
                        width: 100%;
                        &:nth-child(2) {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                        }
                        &:nth-child(3) {
                            text-align: right;
                        }
                    }
                }
            }
        }
    }

    .property {
        // width: 90%;
        margin: 15px 10px;

        height: 158px;

        background: url(../../assets/img/page/hh.png) no-repeat;
        background-size: 100% 100%;

        ::v-deep .number-grow {
            color: #fff !important;
            font-size: 20px;
        }

        ::v-deep .number-grows {
            color: #fff !important;
            font-size: 16px;
            margin-top: 3px;
            display: block;
        }

        p {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */


            /* 白/FE */

            color: #FEFEFE;

            &:nth-child(1) {
                padding: 20px 10px 0 10px;


                // ::v-deep .numsp {

                //     font-size: 15px !important;
                //     border: 1px solid red;
                // }
            }

            span {
                color: #fff;
                font-size: 18px;
            }

            &:nth-child(2) {
                padding: 5px 10px 0 10px;


            }

            .numsp {

                // font-size: 20px !important;
                // border: 1px solid red;
            }
        }

    }

    .Assets_grid {

        ul {
            display: grid;
            justify-content: space-between;
            grid-template-columns: 25% 25% 25% 25%;
            text-align: center;

            li {
                margin-top: 17px;

                img {
                    // margin: 10px 0;
                }

                p {
                    // padding: 8.74px 0px 15px 0;
                    color: #fff;
                    font-size: 12px;
                }
            }

            // align-items: center;
        }
    }

    .Assets_ul {
        ul {
            li {
                margin: 20px 10px;
                background: rgba(20, 132, 195, 0.2);
                /* 黄/主题 */

                border: 0.5px solid #f89b19;
                box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
                border-radius: 4px;

                div {
                    &:nth-child(1) {
                        padding: 10px 15px;

                        p {
                            font-style: normal;
                            font-weight: 400;
                            font-size: 18px;
                            line-height: 25px;
                            text-align: center;

                            color: #FFFFFF;

                            &:nth-child(1) {

                                font-family: 'PingFang SC';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 18px;
                                line-height: 25px;
                                text-align: center;

                                color: #FFFFFF;

                            }


                        }
                    }

                    &:nth-child(2),
                    &:nth-child(3) {
                        display: grid;
                        justify-content: space-between;
                        grid-template-columns: 50% 50%;
                        // border: 1px solid red;
                        padding: 0px 15px;

                        p {
                            font-family: 'PingFang SC';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 16px;
                            width: 100%;
                            line-height: 22px;
                            // border: 1px solid red;

                            /* 白/FE */

                            // color: #FEFEFE;

                            &:nth-child(2) {}
                        }


                    }

                    &:nth-child(2) {
                        padding: 5px 15px;
                        color: #FEFEFE !important;
                    }

                    &:nth-child(3) {
                        padding: 0px 15px 10px 15px;
                        color: #7B7B7B !important;
                    }
                }
            }
        }
    }

}
</style>